export enum ActivityOptionsActions {
  CLONE   = 'clone',
  DELETE  = 'delete',
  PIN     = 'pin',
  RESULTS = 'results',
  SHARE   = 'share'
}
